module.exports = __webpack_public_path__ + "static/img/subbanner2.1cf715f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/banners/subbanner2.jpg
// module id = MMTw
// module chunks = 1